import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=5b4f8aef&"
import script from "./ImageZoom.vue?vue&type=script&lang=js&"
export * from "./ImageZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImageZoom.vue?vue&type=style&index=0&id=5b4f8aef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports